<template>
  <div class="poll-message-card" @click="openVoteModal">
    <div class="poll-message-card__question">{{ mess.poll.question }}</div>
    <div class="poll-message-card__hint" v-if="!pollSingleChoice">Cho phép chọn nhiều câu trả lời</div>
    <div class="poll-message-card__hint" v-if="pollIsAddOption">Cho phép chọn thêm trả lời</div>
    <div class="poll-message-card__hint poll-message-card__hint--expired" v-if="isExpiredTime">
      {{ expiryLabel }}
    </div>
    <button type="button" class="poll-message-card__stats" v-if="uniqueVoterCount > 0" @click.stop="openVoteModal">
      {{ uniqueVoterCount }} người bình chọn
      <span class="material-icons">chevron_right</span>
    </button>

    <div class="poll-message-card__options">
      <div
        v-for="(option, index) in previewOptions"
        :key="'preview-' + index"
        class="poll-message-card__option-row"
      >
        <div class="poll-message-card__option-bar">
          <div
            class="poll-message-card__option-fill"
            :style="{ width: optionPercent(option) + '%' }"
          ></div>
          <div class="poll-message-card__option-text">{{ option.answer }}</div>
        </div>
        <span class="poll-message-card__option-count">{{ option.vote_ids.length }}</span>
      </div>
    </div>

    <div class="poll-message-card__more" v-if="hiddenOptionCount > 0">
      * Còn {{ hiddenOptionCount }} lựa chọn khác
    </div>

    <button type="button" class="poll-message-card__vote-btn" :disabled="isExpiredTime" @click.stop="openVoteModal">
      {{ isExpiredTime ? 'Đã hết hạn' : 'Bình chọn' }}
    </button>
  </div>
</template>

<script>
import moment from 'moment';

const PREVIEW_LIMIT = 3;

export default {
  name: 'PollMessageContent',
  props: {
    mess: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    pollSingleChoice() {
      return !!this.mess?.poll?.single_choice;
    },
    pollIsAddOption() {
      return !!this.mess?.poll?.is_add_option;
    },
    pollOptions() {
      const data = this.mess?.poll?.data;
      return Array.isArray(data) ? data : Object.values(data || {});
    },
    previewOptions() {
      return this.pollOptions.slice(0, PREVIEW_LIMIT);
    },
    hiddenOptionCount() {
      return Math.max(0, this.pollOptions.length - PREVIEW_LIMIT);
    },
    totalVoteCount() {
      return this.pollOptions.reduce((sum, item) => sum + (item.vote_ids?.length || 0), 0);
    },
    uniqueVoterCount() {
      const ids = new Set();
      this.pollOptions.forEach((item) => {
        (item.vote_ids || []).forEach((id) => ids.add(id));
      });
      return ids.size;
    },
    isExpiredTime() {
      if (!this.mess.poll?.expired_time) return false;
      const expiredTimeString = moment(this.mess.poll.expired_time, ['YYYY-MM-DD HH:mm:ss', 'yyyy-MM-DD HH:mm:ss'], true);
      return expiredTimeString.isValid() && expiredTimeString.isBefore(moment());
    },
    expiryLabel() {
      if (!this.mess.poll?.expired_time) return '';
      const expired = moment(this.mess.poll.expired_time, ['YYYY-MM-DD HH:mm:ss', 'yyyy-MM-DD HH:mm:ss'], true);
      if (!expired.isValid()) return 'Giới hạn thời gian cho cuộc bình chọn';
      if (this.isExpiredTime) {
        return `Đã hết hạn lúc ${expired.format('HH:mm, DD/MM/YYYY')}`;
      }
      return `Kết thúc lúc ${expired.format('HH:mm, DD/MM/YYYY')}`;
    },
  },
  methods: {
    optionPercent(option) {
      if (!this.totalVoteCount) return 0;
      return Math.round(((option.vote_ids?.length || 0) / this.totalVoteCount) * 100);
    },
    openVoteModal() {
      this.$modal.show('poll-vote-modal', { mess: this.mess });
    },
  },
};
</script>

<style lang="scss" scoped>
.poll-message-card {
  width: 100%;
  min-width: 320px;
  max-width: 420px;
  background: #fff;
  border: 1px solid #e9eaec;
  border-radius: 12px;
  box-shadow: 0 4px 8px rgba(47, 49, 54, 0.08);
  padding: 16px;
  cursor: pointer;
}

.poll-message-card__question {
  font-size: 18px;
  font-weight: 700;
  line-height: 1.35;
  color: #1c2b4a;
}

.poll-message-card__hint {
  margin-top: 6px;
  font-size: 13px;
  color: #8a8d91;
}

.poll-message-card__hint--expired {
  color: #d93025;
}

.poll-message-card__stats {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  margin-top: 8px;
  border: 0;
  background: transparent;
  padding: 0;
  color: #1b74e4;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
}

.poll-message-card__options {
  margin-top: 12px;
}

.poll-message-card__option-row {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 10px;
  align-items: center;
  margin-bottom: 8px;
}

.poll-message-card__option-bar {
  position: relative;
  min-height: 36px;
  border-radius: 8px;
  background: #f1f2f4;
  overflow: hidden;
}

.poll-message-card__option-fill {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  background: rgba(27, 116, 228, 0.14);
}

.poll-message-card__option-text {
  position: relative;
  z-index: 1;
  padding: 8px 12px;
  font-size: 14px;
  color: #26282c;
  line-height: 1.3;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.poll-message-card__option-count {
  min-width: 20px;
  text-align: right;
  font-size: 14px;
  color: #26282c;
}

.poll-message-card__more {
  margin-top: 4px;
  font-size: 13px;
  color: #8a8d91;
}

.poll-message-card__vote-btn {
  width: 100%;
  margin-top: 14px;
  height: 40px;
  border-radius: 8px;
  border: 1px solid #1b74e4;
  background: #fff;
  color: #1b74e4;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
}

.poll-message-card__vote-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>
